<script setup lang="ts">
  defineProps({
    is: {
      type: String,
      default: 'div',
    },
  })
</script>

<template>
  <component
    :is="is"
    class="col-money">
    <span>Rp</span>
    <span>
      <slot></slot>
    </span>
  </component>
</template>

<style scoped>
@reference "@/assets/styles/main.css";
.col-money {
  @apply flex w-full justify-between space-x-2;
  span {
    @apply block;
  }
}
</style>
